module.exports = __webpack_public_path__ + "img/lg_ring_y_c_0_0.b3e47808.png";